export default __webpack_public_path__ + "static/media/partner-home.5f936eaf.png";